export default {
  admin: () => import("/app/layouts/admin.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  unauthorized: () => import("/app/layouts/unauthorized.vue").then(m => m.default || m)
}